var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_vm._v(" Finally, let's customize how will use the data. ")])],1),_c('v-row')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }